import React, { useState, useEffect, useRef } from 'react';
import CommonSelect from '../../components/Dashboard-res/CommonComponent/CommonSelect';
import { GetLeadStatus } from '../../common/constants/api';

const MBTopStatusFilter = ({
  filter,
  setFilter,
  statusFilterList,
  setStatusFilterList
}) => {
  const statusOptions = function() {
    GetLeadStatus()
      .then(res => {
        if (res) {
          let status_list = [],
            status_dict;
          for (let i = 0; i < res.length; i++) {
            status_dict = {
              label: res[i].toString(),
              value: res[i].toString()
            };
            status_list.push(status_dict);
          }
          setStatusFilterList(status_list);
        }
      })
      .catch(err => {});
  };
  useEffect(() => {
    statusOptions();
  }, []);
  return (
    <CommonSelect sort={true}
      name="lead_status"
      value={filter}
      onChange={e => {
        setFilter({ value: e.value, label: e.value });
      }}
      onBlur={() => {}}
      options={[
        {
          label: 'ALL',
          value: 'ALL'
        },
        ...statusFilterList
      ]}
      stylesContainer={{
        height: '30px',
        marginBottom: '0px',
        fontSize: '40px',
        width: '130px',
        padding: '6px 0px',
        border: 'none',
        outline: 'none'
      }}
      dropdownStyle={{
        top: '30px'
      }}
      styleText={{
        fontSize: '14px'
      }}
    />
  );
};

export default MBTopStatusFilter;
